import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createClient } from "@supabase/supabase-js";
import "../Login/Login.css";
import logo from "../../assets/dr-is-in.png";

const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  "https://zvacumxidqqaueuruwnj.supabase.co";

const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp2YWN1bXhpZHFxYXVldXJ1d25qIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg1NTk4ODQsImV4cCI6MjA5NDEzNTg4NH0.PkuVH1cMeGpG5GTckXBNuSdvWFwUij27s25M1MkKYgQ";

const supabase = createClient(supabaseUrl, supabaseAnonKey);

function clean(v: any) {
  return String(v ?? "").trim();
}

export default function ContactUsIssues() {
  const navigate = useNavigate();
  const year = new Date().getFullYear();

  const [body, setBody] = useState("");
  const [file, setFile] = useState<File | null>(null);

  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState<{ kind: "ok" | "err"; text: string } | null>(null);

  const canSubmit = useMemo(() => clean(body).length >= 10, [body]);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setMsg(null);
    setSubmitting(true);

    try {
      const issueMessage = [
        "App Issue Report",
        file?.name ? `Screenshot file selected: ${file.name}` : "Screenshot file selected: No",
        "",
        clean(body),
      ].join("\n");

      const { error } = await supabase.from("contacts").insert({
        contact_type: "issue",
        message: issueMessage,
        created_by: "public_user",
      });

      if (error) throw error;

      setMsg({
        kind: "ok",
        text: file ? "Thanks — issue submitted. Screenshot name was noted." : "Thanks — issue submitted.",
      });

      setBody("");
      setFile(null);

      setTimeout(() => navigate("/contact-us"), 700);
    } catch (e: any) {
      setMsg({ kind: "err", text: e?.message || "Submit failed." });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Doctor Is In Logo" className="login-logo" />
        <h2 className="login-title">App Issues</h2>

        {msg && (
          <div
            style={{
              width: "100%",
              margin: "10px 0",
              padding: "10px 12px",
              borderRadius: 10,
              fontSize: 13,
              border: "1px solid rgba(0,0,0,0.12)",
              background: msg.kind === "ok" ? "rgba(0,0,0,0.04)" : "rgba(255,0,0,0.10)",
              color: "#111",
              textAlign: "center",
            }}
          >
            {msg.text}
          </div>
        )}

        <form onSubmit={submit} className="login-actions">
          <textarea
            className="login-input"
            placeholder="Tell us about the trouble you are having with our App..."
            value={body}
            onChange={(e) => setBody(e.target.value)}
            rows={6}
            required
            disabled={submitting}
          />

          <input
            type="file"
            accept="image/*"
            onChange={(e) => setFile(e.target.files?.[0] || null)}
            disabled={submitting}
          />

          <button type="submit" className="login-btn" disabled={submitting || !canSubmit}>
            {submitting ? "Submitting..." : "Submit"}
          </button>

          <button type="button" className="login-btn" onClick={() => navigate("/contact-us")} disabled={submitting}>
            ← Back
          </button>
        </form>

        <div className="login-footer">© {year} Doctor Is In App. All rights reserved.</div>
      </div>
    </div>
  );
}